import { Link as RouterLink, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import pageTitleFromPathname from '../../helpers/pageTitleFromPathname';
import useActiveInfo from '../../Hooks/useActiveInfo';
const useStyles = makeStyles(theme => ({
    root: {
        '& a': {
            '&:hover': {
                textDecoration: 'underline',
            },
            color: 'inherit',
        },
        '& li:nth-of-type(2) svg': {
            display: 'none',
        },
        backgroundColor: 'transparent',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
    },
    breadcrumbs: {
        background: theme.palette.common.white,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
}));

const ConnectedBreadcrumbs = ({ location }: any) => {
    const classes = useStyles();

    const nameMap = useActiveInfo();

    const pathnames = location.pathname.split('/').filter((x: any) => x);

    interface TParams {
        id: string;
    }
    return (
        <div className={classes.root}>
            <Breadcrumbs
                aria-label="Breadcrumb"
                classes={{ root: classes.breadcrumbs }}
                data-cy="Breadcrumbs"
                separator={<NavigateNextIcon fontSize="small" />}
            >
                <RouterLink color="inherit" to="/"></RouterLink>

                {pathnames.map((value: any, index: any) => {
                    const last = index === pathnames.length - 1;
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                    return last ? (
                        <Typography color="textPrimary" key={to}>
                            {pageTitleFromPathname(nameMap)[to]}
                        </Typography>
                    ) : (
                        <RouterLink color="inherit" key={to} to={to}>
                            {pageTitleFromPathname(nameMap)[to]}
                        </RouterLink>
                    );
                })}
            </Breadcrumbs>
        </div>
    );
};

export default withRouter(ConnectedBreadcrumbs);
